import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Rocket } from 'lucide-react';
import { useFacility } from '../../context/FacilityContext';
import { InfoBanner, Button } from '../../components/ui';

/**
 * Persistent banner shown in the dashboard when the active facility is in
 * 'trial' or 'suspended' state. Hidden for active facilities.
 */
export default function TrialBanner() {
  const navigate = useNavigate();
  const { facilityStatus } = useFacility();

  if (facilityStatus === 'trial') {
    return (
      <InfoBanner variant="info" title="Trial mode" icon={Rocket}>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <span>Your facility is not yet public. Complete setup and subscribe to go live.</span>
          <Button
            variant="primary"
            className="shrink-0 self-start px-3 py-1.5 text-xs sm:self-auto"
            onClick={() => navigate('/dashboard/subscribe')}
          >
            Go live →
          </Button>
        </div>
      </InfoBanner>
    );
  }

  if (facilityStatus === 'suspended') {
    return (
      <InfoBanner variant="danger" title="Facility suspended">
        Public bookings are paused. Please contact support to reactivate.
      </InfoBanner>
    );
  }

  return null;
}
